var angular = require('angular')

angular.module('AemCspsDisbursementCalculator')
  .component('tab', {
    template: require('./tab.component.tpl.html'),
    controller: TabCtrl,
    controllerAs: 'vm',
    bindings: {}
  })

TabCtrl.$inject = ['$location']

function TabCtrl ($location) {
  var vm = this

  vm.$onInit = function () {
    vm.isDps = $location.path() === '/dps'
    vm.isPp = $location.path() === '/pp'
  }
}
